import { ApiCrudObjectControllerBindings, EmploymentCrudController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Renders an edit view for single Employment relation (Worker for one Employer).
 * @example
 * ```html
 * <salaxy-employment-details-edit></salaxy-employment-details-edit>
 * ```
 */
export class EmploymentDetails extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = (new class extends ApiCrudObjectControllerBindings {

      /** Current tab in initialization. */
      public currentTab = "@";

      /** If true, the component is shown in modal: Hide buttons and switch employment works in a different way. */
      public isModal = "<";
    }());

    /** Uses the EmploymentCrudController */
    public controller = EmploymentCrudController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/worker/employment/Details.html";

}
